// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_CarregaOrcamentoServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /orcamentos_servicos/carregaOrcamentoServico
 *
 * Returns a single orcamento_servico record with computed labels.
 */
import type { OrcamentosServicos_CarregaOrcamentoServicoRow } from './OrcamentosServicos_CarregaOrcamentoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_CarregaOrcamentoServicoResponseDados = OrcamentosServicos_CarregaOrcamentoServicoRow;

export type OrcamentosServicos_CarregaOrcamentoServicoResponse = ApiResponse<OrcamentosServicos_CarregaOrcamentoServicoResponseDados>;

registerResponseContract('OrcamentosServicos_CarregaOrcamentoServicoResponse', {
  orcamento_servico_id:            { type: 'number',  required: true },
  orcamento_id:                    { type: 'number',  required: true },
  servico_id:                      { type: 'number',  required: true },
  servico_valor:                   { type: 'number',  required: true },
  orcamento_servico_qtd:           { type: 'number',  required: true },
  orcamento_servico_status:        { type: 'number',  required: true },
  orcamento_servico_tipo:          { type: 'number',  required: true },
  orcamento_servico_user_id:       { type: 'string',  required: false },
  orcamento_servico_data_cadastro: { type: 'string',  required: false },
  servico_label:                   { type: 'string',  required: false },
  status_label:                    { type: 'string',  required: false },
  tipo_label:                      { type: 'string',  required: false },
})
